module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "بغداد-في-منتصف-الخمسينيات"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بغدادُ في مُنتصفِ الخمسينيات")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("رجع إلى البيت متأخِّرًا وألقى بجَسده المُتعَب على الفراش، حاولَ النوم لكنّه فشل عندما فضَّل عقلُه الاستمرار برسم التّخيُّلات وعرض الذّكريات والمَشاهد الّتي تؤذي روحَه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أقبلَ الأستاذُ \"صباح\" وقالَ لهُ:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صباح الخير يا باشا، أراكَ ما زلتَ في فراشِك!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم يردّ عزّام.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ماذا حصلَ؟ هل مرضتَ مرّةً أخرى؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم يردّ عزّام.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فقالَ صباحُ بعدَ أن تحسّس جبينَ ابنه:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- سأبقى بجانبكَ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا داعي لأنْ تَبْقى يا أبي!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ابتسمَ وقالَ: فهمتُ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لِمَ هذه الابتسامةُ؟ أنا لم أعد طفلًا!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ظلّ الأستاذ \"صباح\" مُبتسمًا وهو خارجٌ من الغرفةِ إلى الصّالة، حملَ الهاتف بيدهِ وسحب السّلكَ وأخذَ يَلفُّه، ورجعَ إلى غرفة عزّام ووضعَ الهاتفَ بجانب السّرير وغادرَ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("انتظرَ عزّام حتّى خرجَ والدُه من المنزلِ، وعلى الفور رفعَ سمّاعة الهاتف ووضعَها على أذنهِ واتّصل بها، ولم يكُن بحاجةٍ أن يقول لها شيئًا لتفهمَ أنّهُ أُصيبَ بالحُمّى من جديد.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أمّي! قالَها بصوتٍ مبحوحٍ مُنْهكٍ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أغلقتِ الهاتفَ بعدَ الانتهاء من المكالمةِ، ونادَت على مساعدِيها ليُجهِّزوا لها السّيارة، لَبِست مِعطفها وأخذتْ حقيبتَها، ثمَّ خرجت من المصنعِ متّجهةً إلى منزلِ الأستاذ \"صباح الحمداني\".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أَسْرِعْ قليلًا\". قالَت للسّائقِ، ثمَّ رجعَت إلى الوراء مُسندةً ظَهْرها، وعيناها إلى السَّماء، مُسترجعةً بعضَ الذّكريات.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a10bb7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch008.vue
// module id = 81
// module chunks = 0